import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { TrackEventContext } from 'common/containers/EventContainer';
import LandingAboutHelmet from 'common/helmets/LandingAboutHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import UppercaseHeader from 'common/UppercaseHeader';
import withContexts from 'common/util/withContexts';
import ClarePhoto from 'img/about/clare.webp';
import EricPhoto from 'img/about/eric.webp';
import FoundersPhoto from 'img/about/founders.webp';
import JimmyPhoto from 'img/about/jimmy.webp';
import JuliaPhoto from 'img/about/julia.webp';
import KamanPhoto from 'img/about/kaman.webp';
import MertPhoto from 'img/about/mert.webp';
import OlivierPhoto from 'img/about/olivier.webp';
import RamiroPhoto from 'img/about/ramiro.webp';
import SaraPhoto from 'img/about/sara.webp';

import 'css/components/www/_LandingAboutPage.scss';

class LandingAboutPage extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed About Page');
  }

  render() {
    return (
      <div className="landingAboutPage">
        <LandingAboutHelmet />
        <div className="landingAboutPageContainer">
          <div className="header">
            <span className="title">Our story</span>
            <span className="subtitle">
              As a user, giving feedback was always disappointing. We're setting out to change that.
              With roots from Facebook, building product is our bread and butter. We're using what
              we're great at, building great products, to have the impact we want to have on
              the&nbsp;world.
            </span>
          </div>
          <div className="header">
            <span className="title">Our team</span>
            <span className="subtitle">
              Canny’s team is small and nimble. We are fully bootstrapped and we work remotely.
              Individually, we are masters at our own craft. Together, we make a killer combo;
              laser-focused on creating the best product experiences and helping others do
              the&nbsp;same.
              <div className="hiring">
                <a href="https://careers.canny.io">
                  <UppercaseHeader>
                    Join the team! <span className="icon-chevron-right" />
                  </UppercaseHeader>
                </a>
              </div>
            </span>
          </div>
          <div className="teamGrid">
            <div className="gridRow">
              <div className="teammate double">
                <div className="imgContainer">
                  <LazyLoadedImage loading="eager" src={FoundersPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Sarah Hum</div>
                    <div className="title">Founder</div>
                    <div className="description">
                      <p>
                        Lover of parfaits and a cappella enthusiast 🎵 After&nbsp;graduating in
                        graphic design, Sarah worked at Facebook. She designed on Messenger with the
                        best of the&nbsp;best.
                      </p>
                      <p>
                        She started Canny back in design school. The original designs are
                        horrendous.
                      </p>
                    </div>
                  </div>
                  <div className="bio">
                    <div className="name">Andrew Rasmussen</div>
                    <div className="title">Founder</div>
                    <div className="description">
                      <p>
                        Software engineer by day ☀️ gamer and dog daddy by night 🌙 Andrew also
                        worked at Facebook, where he was one of the first engineers to work on the
                        popular open source project, React&nbsp;Native.
                      </p>
                      <p>
                        If you ever run into a bug while using Canny, it's his fault and he's
                        very&nbsp;sorry.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="spacer" />
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={RamiroPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Ramiro Olivera</div>
                    <div className="title">Engineering</div>
                    <div className="description">
                      <p>
                        Code enthusiast, guitar player, and film lover 📽 Ramiro has built software
                        for companies of all sizes, but he’d rather help build&nbsp;Canny.
                      </p>
                      <p>
                        Ramiro spends more time debugging than coding but he introduces
                        bugs&nbsp;anyway.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gridRow">
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={MertPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Mert Batmazoğlu</div>
                    <div className="title">Engineering</div>
                    <div className="description">
                      <p>
                        Tennis player, book and comic geek 🤓 and lover of Irish folk music. Mert
                        has worked for several startups, included one he&nbsp;co&#8209;founded.
                      </p>
                      <p>Mert might be part humanoid 🤖—he works like there's no&nbsp;tomorrow.</p>
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="spacer" />
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={EricPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Eric Hoppe</div>
                    <div className="title">Marketing</div>
                    <div className="description">
                      <p>
                        Marketer and aspiring dog-sport competitor 🐕 Eric’s career features stints
                        with innovative companies like Opera Software and Crowd&nbsp;Content.
                      </p>
                      <p>
                        When he’s not telling the world how great Canny is, Eric's finding ways to
                        get his dogson to be a more competitive frisbee&nbsp;dog.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="spacer" />
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={ClarePhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Clare Garrity</div>
                    <div className="title">Operations</div>
                    <div className="description">
                      <p>
                        Clare is a true generalist. Since 2014, she has lead the operations, people,
                        and culture functions at numerous SaaS companies across
                        three&nbsp;continents.
                      </p>
                      <p>
                        When not working closely with Andrew on ops, she can be found walking the
                        Vancouver sea wall with her dog Chico, or&nbsp;painting&nbsp;🎨
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gridRow">
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={SaraPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Sara Al Mouaswas</div>
                    <div className="title">Engineering</div>
                    <div className="description">
                      <p>
                        After spending the majority of her career as a consultant, Sara has now
                        joined forces with Canny as a software&nbsp;developer!
                      </p>
                      <p>
                        In her personal life, she is a dog mom to a 75lb Goldendoodle and a 7lb Shih
                        Tzu and can be found struggling to walk them both at the
                        same&nbsp;time&nbsp;🐾
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="spacer" />
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={KamanPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Kaman Hui</div>
                    <div className="title">Marketing</div>
                    <div className="description">
                      <p>
                        Serial Netflix watcher, personality tests and riddles lover 🕵️‍♀️ Kaman likes
                        all things psychological and enjoys learning random things like
                        tea&nbsp;tasting.
                      </p>
                      <p>
                        When she is not obsessing over optimizing Canny's ad campaigns, Kaman is
                        probably out playing boardgames or&nbsp;dancing&nbsp;💃
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="spacer" />
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={JuliaPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Julia Valade</div>
                    <div className="title">Customer Success</div>
                    <div className="description">
                      <p>
                        Julia is always looking to grow and try new things. She is "that" friend who
                        encourages you to achieve your goals and think outside the&nbsp;box!&nbsp;🙌
                      </p>
                      <p>
                        When she's not driving customer success, you'll catch Julia lost in books
                        about grand adventure 📚 or off on her own outdoor&nbsp;escapades.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gridRow">
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={JimmyPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Jimmy Comodeca</div>
                    <div className="title">Sales</div>
                    <div className="description">
                      <p>
                        Jimmy is a sales wizard 🧙‍♂️ and entrepreneurial spirit. He has a knack for
                        selling cutting-edge tech and even built his own startup from the
                        ground&nbsp;up.
                      </p>
                      <p>
                        When he’s not closing deals, you can find him strumming his guitar, planning
                        his next bikepacking adventure 🚴‍♂️ or kicking around a soccer&nbsp;ball.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="spacer" />
              <div className="teammate">
                <div className="imgContainer">
                  <LazyLoadedImage src={OlivierPhoto} />
                </div>
                <div className="bioContainer">
                  <div className="bio">
                    <div className="name">Olivier Castro-Perrier</div>
                    <div className="title">Engineering</div>
                    <div className="description">
                      <p>
                        Software engineer and self-taught baker 👨‍🍳 Olivier has built products for
                        startups of all sizes, and he’s excited to help build the future
                        of&nbsp;Canny.
                      </p>
                      <p>
                        When he’s not coding, you’ll find him experimenting with new recipes or
                        tackling a DIY project at&nbsp;home&nbsp;🛠️
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA
            ctaTo="https://canny.io/blog"
            ctaValue="Check it out"
            message="We're sharing our journey on our&nbsp;blog"
            style="solid"
          />
        </div>
      </div>
    );
  }
}

export default compose(withContexts({ trackEvent: TrackEventContext }), hot)(LandingAboutPage);
